import { Component, OnInit } from '@angular/core';
import { ApiService } from '../../shared/services/api/api.service';
import { UserSessionService } from '../../shared/services/user-session.service';
import { firstValueFrom } from 'rxjs';
import { ImpersonationService } from '../../shared/services/impersonation.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiUserService } from '../../shared/services/api/user/api-user.service';

@Component({
  templateUrl: 'impersonate.component.html',
  styleUrls: ['./impersonate.component.scss']
})
export class ImpersonateComponent implements OnInit {
  loading = false;
  constructor(
    private apiService: ApiService,
    private apiUserService: ApiUserService,
    private userSessionService: UserSessionService,
    private impersonationService: ImpersonationService,
    private route: ActivatedRoute,
    private router: Router,
  ) {}

  async ngOnInit() {
    this.impersonationService.setImpersonatedUser('');
    this.loading = true;
    const token = this.route.snapshot.queryParamMap.get('token') || '';
    if (!token) {
      this.loading = false;
      await this.router.navigate(['/login']);
      return;
    }
    localStorage.setItem('api_token', token);

    const body = ["email", "first_name", "last_name", "group_account_id", "modules", "id"];
    const user = await firstValueFrom(this.apiUserService.searchUserWithFields(body));
    if (user?.id  && user?.modules){
      const userSession = {
        apiToken: token,
        email : user.email,
        firstName : user.firstName,
        lastName : user.lastName,
        groupAccountId : user.groupAccountId,
        modules: user.modules,
        id : user.id,
      }
      this.userSessionService.userSession = userSession;
      this.impersonationService.setImpersonatedUser(user.email);
    }
    this.impersonationService.notifyFinished();
    this.loading = false;
    await this.router.navigate(['/search']);
  }


}
